import { FC } from "react";
import { Flex, Stack, Text } from "flicket-ui";
import { Calendar, MapPin } from "phosphor-react";
import { OfferingCallToAction, IOfferingAction } from "./OfferingCallToAction";

interface OfferingHeaderProps {
  title: string;
  location?: string;
  date?: string;
  actions: IOfferingAction[];
}

export const OfferingHeader: FC<OfferingHeaderProps> = ({
  title,
  location,
  date,
  actions,
}) => {
  return (
    <Flex flexDirection="row" justifyContent="space-between" space={2} py={2}>
      <Stack direction="vertical" alignItems="flex-start" gap={1} mb={2}>
        <Text variant="header.L" color="N800">
          {title}
        </Text>
        {location && (
          <Stack direction="horizontal" alignItems="center" gap={1}>
            <MapPin />
            <Text>{location}</Text>
          </Stack>
        )}
        {date && (
          <Stack direction="horizontal" alignItems="center" gap={1}>
            <Calendar />
            <Text>{location}</Text>
          </Stack>
        )}
      </Stack>
      <OfferingCallToAction actions={actions} />
    </Flex>
  );
};
